import { ComponentProps, forwardRef, useContext } from 'react';
import { InView } from 'react-intersection-observer';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { DialogCompositeMui as DialogComposite } from '../DialogCompositeMui';
import { StepContext } from '../MultiStepDialog/context';

const styles = createStyles({
  root: {
    padding: 0,
    overflowX: 'visible',
  },
});

export type BodyProps = WithStyles<typeof styles> &
  ComponentProps<typeof DialogComposite.Body>;

const Body = forwardRef<HTMLDivElement, BodyProps>((props, ref) => {
  const { classes, className, children, ...rest } = props;
  const { forceReview, setSeenEverything } = useContext(StepContext);

  return (
    <div ref={ref} className={classNames(classes.root, className)} {...rest}>
      {children}
      {forceReview && (
        <InView onChange={inView => inView && setSeenEverything(true)} />
      )}
    </div>
  );
});

Body.displayName = 'MultiStepDialog.Body';

export default withStyles(styles)(Body);
